import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import {
  UiMonthMultiselectComponent,
  UiMultiselectComponent,
  UiSelectOption,
  UiYearMultiselectComponent,
} from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

const AMENITIES: UiSelectOption[] = [
  { id: 'alberca', label: 'Alberca' },
  { id: 'gym', label: 'Gimnasio' },
  { id: 'salon', label: 'Salón de eventos' },
  { id: 'terraza', label: 'Terraza' },
  { id: 'estacionamiento', label: 'Estacionamiento' },
  { id: 'seguridad', label: 'Seguridad 24h' },
  { id: 'juegos', label: 'Área de juegos', disabled: true },
  { id: 'coworking', label: 'Coworking' },
  { id: 'rooftop', label: 'Rooftop' },
];

const ROOMS: UiSelectOption[] = [
  { id: 1, label: '1 recámara' },
  { id: 2, label: '2 recámaras' },
  { id: 3, label: '3 recámaras' },
  { id: 4, label: '4 recámaras' },
  { id: 5, label: '5 o más recámaras' },
];

@Component({
  selector: 'app-multiselect-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiMultiselectComponent, UiYearMultiselectComponent, UiMonthMultiselectComponent, AppExampleSectionComponent],
  templateUrl: './multiselect-doc.component.html',
  styleUrl: './multiselect-doc.component.scss',
})
export class MultiselectDocComponent {
  protected readonly amenities = AMENITIES;
  protected readonly rooms = ROOMS;

  protected readonly selectedAmenities = signal<UiSelectOption[]>([]);
  protected readonly selectedRooms = signal<UiSelectOption[]>([]);
  protected readonly selectedYears = signal<UiSelectOption[]>([]);
  protected readonly selectedMonths = signal<UiSelectOption[]>([]);
  protected readonly isInvalid = signal(false);
  protected readonly showErrorMsg = signal(true);

  protected toggleInvalid(): void {
    this.isInvalid.update((v) => !v);
  }

  protected toggleErrorMsg(): void {
    this.showErrorMsg.update((v) => !v);
  }
}
